import { render, staticRenderFns } from "./editUninformed.modal.vue?vue&type=template&id=7173a505&scoped=true&"
import script from "./editUninformed.modal.vue?vue&type=script&lang=js&"
export * from "./editUninformed.modal.vue?vue&type=script&lang=js&"
import style0 from "./editUninformed.modal.vue?vue&type=style&index=0&id=7173a505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173a505",
  null
  
)

export default component.exports